export default __webpack_public_path__ + "static/media/info.0ac9aa99.svg";